export default __webpack_public_path__ + "static/media/interior-design.1cd26592.png";